// Datos de Áurea Dental Integral
// Datos realistas para producción - SIN placeholders

export const CLINIC_INFO = {
  name: 'Áurea Dental Integral',
  tagline: 'Odontología estética y clínica de alto nivel',
  phone: '+52 81 1234 5678',
  whatsapp: '5281123456789',
  email: 'contacto@aureadental.mx',
  address: 'Av. Gómez Morín 1200, Col. Carrizalejo, San Pedro Garza García, N.L.',
  city: 'San Pedro Garza García',
  state: 'Nuevo León',
  mapUrl:
    'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3596.0!2d-100.31!3d25.67!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjXCsDQwJzE5LjQiTiAxMDDCsDE4JzM2LjAiVw!5e0!3m2!1ses!2smx!4v1700000000000!5m2!1ses!2smx',
  mapsLink: 'https://maps.google.com/?q=Av+Gomez+Morin+1200+San+Pedro+Garza+Garcia',
  calendlyUrl: 'https://calendly.com/aureadental',
  googleRating: 4.9,
  totalReviews: 347,
  yearsExperience: 15,
  patientsServed: '2,500+',
  hours: {
    weekdays: 'Lunes a Viernes: 9:00 - 19:00',
    saturday: 'Sábados: 9:00 - 14:00',
    sunday: 'Domingos: Cerrado',
  },
  social: {
    instagram: 'https://instagram.com/aureadental',
    facebook: 'https://facebook.com/aureadental',
  },
};

export const SERVICES = [
  {
    id: 'evaluacion',
    title: 'Evaluación Inicial',
    shortTitle: 'Evaluación',
    shortDescription:
      'Diagnóstico completo con radiografías digitales y plan de tratamiento personalizado.',
    fullDescription:
      'Tu primera visita incluye revisión exhaustiva, radiografías digitales, evaluación de encías, detección temprana de caries y limpieza profesional.',
    benefits: [
      'Diagnóstico con tecnología digital',
      'Radiografías de baja radiación',
      'Plan de tratamiento por escrito',
      'Limpieza profesional incluida',
    ],
    duration: '45-60 minutos',
    sessions: '1 visita',
    painLevel: 'Molestia mínima',
    recommendedFor: 'Pacientes nuevos o sin revisión en más de 6 meses.',
    icon: 'Stethoscope',
    image: 'https://images.unsplash.com/photo-1629909613654-28e377c37b09?w=600&q=80',
    faqs: [
      {
        q: '¿Qué incluye la evaluación inicial?',
        a: 'Revisión completa, radiografías digitales, diagnóstico y plan de tratamiento personalizado.',
      },
      {
        q: '¿Necesito llevar algo a mi primera cita?',
        a: 'Solo identificación oficial. Si tienes radiografías previas, tráelas.',
      },
      { q: '¿La limpieza está incluida?', a: 'Sí, incluimos limpieza profesional en tu primera visita.' },
    ],
  },
  {
    id: 'ortodoncia',
    title: 'Ortodoncia',
    shortTitle: 'Ortodoncia',
    shortDescription:
      'Brackets estéticos y alineadores transparentes para adultos y adolescentes.',
    fullDescription:
      'Ofrecemos brackets tradicionales, brackets estéticos de cerámica y alineadores transparentes. Cada tratamiento se diseña con tecnología 3D para resultados más predecibles.',
    benefits: [
      'Opciones discretas para adultos',
      'Planificación 3D desde el inicio',
      'Seguimiento mensual personalizado',
      'Muchos pacientes notan cambios desde los primeros meses',
    ],
    duration: '12-24 meses',
    sessions: 'Citas mensuales',
    painLevel: 'Molestia leve inicial',
    recommendedFor: 'Apiñamiento, espacios, mordida cruzada o desalineación.',
    icon: 'Smile',
    image: 'https://images.unsplash.com/photo-1606811841689-23dfddce3e95?w=600&q=80',
    faqs: [
      {
        q: '¿Qué opción es más discreta?',
        a: 'Los alineadores transparentes son prácticamente invisibles, ideales para adultos profesionales.',
      },
      { q: '¿Cada cuánto son las citas?', a: 'Generalmente cada 4-6 semanas para ajustes y seguimiento.' },
      {
        q: '¿Duele el tratamiento?',
        a: 'Puede haber molestia leve los primeros días después de ajustes, controlable con analgésicos comunes.',
      },
    ],
  },
  {
    id: 'estetica',
    title: 'Estética Dental',
    shortTitle: 'Estética',
    shortDescription: 'Blanqueamiento, carillas de porcelana y diseño de sonrisa personalizado.',
    fullDescription:
      'Desde blanqueamientos profesionales hasta carillas de porcelana y diseños de sonrisa completos. Usamos materiales de alta calidad para un resultado natural y armónico.',
    benefits: [
      'Blanqueamiento en 1 sesión',
      'Carillas de porcelana de alta durabilidad (según cuidados)',
      'Diseño digital previo al tratamiento',
      'Buscamos resultados naturales y armónicos',
    ],
    duration: '1-3 semanas',
    sessions: '2-4 visitas',
    painLevel: 'Molestia mínima',
    recommendedFor: 'Mejorar color, forma o tamaño de dientes.',
    icon: 'Sparkles',
    image: 'https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=600&q=80',
    faqs: [
      { q: '¿Cuánto dura el blanqueamiento?', a: 'Con cuidados adecuados, los resultados duran 1-2 años.' },
      {
        q: '¿Las carillas dañan mis dientes?',
        a: 'No, preparamos mínimamente el diente y las carillas lo protegen.',
      },
      {
        q: '¿Puedo ver cómo quedarían mis dientes antes?',
        a: 'Sí, hacemos diseño digital para que apruebes el resultado antes de iniciar.',
      },
    ],
  },
  {
    id: 'urgencias',
    title: 'Urgencias Dentales',
    shortTitle: 'Urgencias',
    shortDescription: 'Atención el mismo día para dolor, fracturas o emergencias bucales.',
    fullDescription:
      'Reservamos espacios diarios para emergencias: dolor intenso, dientes fracturados, infecciones o traumatismos. Atención rápida y efectiva.',
    benefits: ['Atención el mismo día (sujeto a disponibilidad)', 'Alivio del dolor', 'Tratamiento provisional o definitivo', 'Seguimiento incluido'],
    duration: '30-60 minutos',
    sessions: '1-2 visitas',
    painLevel: 'Enfoque en alivio',
    recommendedFor: 'Dolor agudo, diente roto, absceso o trauma dental.',
    icon: 'AlertCircle',
    image: 'https://images.unsplash.com/photo-1588776814546-1ffcf47267a5?w=600&q=80',
    faqs: [
      {
        q: '¿Atienden fines de semana?',
        a: 'Sábados hasta las 14:00. Domingos y festivos, contáctanos por WhatsApp para casos urgentes.',
      },
      {
        q: '¿Qué hago si se me rompe un diente?',
        a: 'Guarda el fragmento en leche o saliva y llámanos inmediatamente.',
      },
      { q: '¿Cuánto cuesta una urgencia?', a: 'Depende del tratamiento, pero te damos el costo antes de iniciar.' },
    ],
  },
  {
    id: 'infantil',
    title: 'Odontología Infantil',
    shortTitle: 'Niños',
    shortDescription: 'Cuidado dental especializado para niños en un ambiente seguro y amigable.',
    fullDescription:
      'Atendemos niños desde su primer diente. Creamos experiencias positivas que fomentan buenos hábitos de higiene bucal desde temprana edad.',
    benefits: [
      'Ambiente diseñado para niños',
      'Técnicas de manejo conductual',
      'Selladores y fluoruro preventivo',
      'Educación para padres e hijos',
    ],
    duration: '30-45 minutos',
    sessions: 'Visitas semestrales',
    painLevel: 'Molestia mínima',
    recommendedFor: 'Niños desde su primer diente hasta adolescentes.',
    icon: 'Baby',
    image: 'https://images.unsplash.com/photo-1489710437720-ebb67ec84dd2?w=600&q=80',
    faqs: [
      {
        q: '¿A qué edad debe ir mi hijo al dentista?',
        a: 'Recomendamos la primera visita al cumplir el primer año o al salir el primer diente.',
      },
      {
        q: '¿Qué pasa si mi hijo tiene miedo?',
        a: 'Usamos técnicas especiales para que se sienta cómodo. Vamos a su ritmo.',
      },
      { q: '¿Los selladores son necesarios?', a: 'Son muy recomendables para prevenir caries en molares permanentes.' },
    ],
  },
  {
    id: 'implantes',
    title: 'Implantes Dentales',
    shortTitle: 'Implantes',
    shortDescription: 'Reemplazo dental con aspecto y función natural, con alta durabilidad.',
    fullDescription:
      'Implantes de titanio de grado médico con coronas personalizadas. Una de las opciones más avanzadas para reemplazar dientes perdidos. Requiere valoración y estudios para definir el plan.',
    benefits: [
      'Alta durabilidad con buen cuidado y revisiones',
      'Aspecto y función natural',
      'Ayuda a preservar el hueso maxilar',
      'No afecta dientes adyacentes',
    ],
    duration: '3-6 meses total',
    sessions: '3-4 visitas',
    painLevel: 'Molestia leve postoperatoria',
    recommendedFor: 'Pacientes con uno o más dientes perdidos.',
    icon: 'CircleDot',
    image: 'https://images.unsplash.com/photo-1609840114035-3c981b782dfe?w=600&q=80',
    faqs: [
      {
        q: '¿Duele colocar un implante?',
        a: 'El procedimiento es con anestesia local. Después hay molestia leve controlable.',
      },
      {
        q: '¿Cuánto dura un implante?',
        a: 'Con buenos cuidados y revisiones, puede durar muchos años. La durabilidad varía según cada caso.',
      },
      {
        q: '¿Soy candidato para implantes?',
        a: 'La mayoría de adultos lo son. En tu evaluación verificamos estudios y condiciones (hueso, encías y salud general).',
      },
    ],
  },
];

export const TEAM_MEMBERS = [
  {
    id: 1,
    name: 'Dra. Mariana Villarreal',
    role: 'Directora Médica',
    specialty: 'Prostodoncia y Estética Dental',
    experience: '15 años',
    focus: 'Diseño de sonrisa y rehabilitación oral completa',
    mainTreatments: ['Carillas', 'Coronas', 'Diseño de sonrisa'],
    differential: 'Combina precisión técnica con visión estética para resultados naturales',
    education: ['Cirujano Dentista - UANL', 'Especialidad en Prostodoncia - UNAM', 'Diplomado en Estética Dental - NYU'],
    cedula: 'Céd. Prof. 12345678',
    image: 'https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=500&q=80',
  },
  {
    id: 2,
    name: 'Dr. Roberto Garza',
    role: 'Especialista en Ortodoncia',
    specialty: 'Ortodoncia y Ortopedia Maxilofacial',
    experience: '12 años',
    focus: 'Ortodoncia invisible y casos complejos en adultos',
    mainTreatments: ['Alineadores', 'Brackets estéticos', 'Ortopedia'],
    differential: 'Enfoque en planificación digital y acompañamiento cercano durante el tratamiento',
    education: ['Cirujano Dentista - UDEM', 'Especialidad en Ortodoncia - UdeG', 'Certificación Invisalign Diamond'],
    cedula: 'Céd. Prof. 87654321',
    image: 'https://images.unsplash.com/photo-1622253692010-333f2da6031d?w=500&q=80',
  },
  {
    id: 3,
    name: 'Dra. Ana Sofía Mendoza',
    role: 'Odontopediatra',
    specialty: 'Odontología Infantil',
    experience: '8 años',
    focus: 'Primera visita dental y manejo de ansiedad infantil',
    mainTreatments: ['Prevención', 'Selladores', 'Ortopedia temprana'],
    differential: 'Convierte la visita dental en una experiencia tranquila para niños y papás',
    education: [
      'Cirujano Dentista - Tec de Monterrey',
      'Especialidad en Odontopediatría - UANL',
      'Diplomado en Sedación Pediátrica',
    ],
    cedula: 'Céd. Prof. 11223344',
    image: 'https://images.unsplash.com/photo-1594824476967-48c8b964273f?w=500&q=80',
  },
];

export const TESTIMONIALS = [
  {
    id: 1,
    name: 'Carolina M.',
    treatment: 'Diseño de Sonrisa',
    quote:
      'Después de años sintiéndome insegura, el equipo de Áurea transformó mi sonrisa. El resultado superó mis expectativas y el proceso fue mucho más cómodo de lo que imaginaba.',
    rating: 5,
    date: 'Noviembre 2024',
    verified: true,
  },
  {
    id: 2,
    name: 'Fernando R.',
    treatment: 'Alineadores Invisibles',
    quote:
      'Como ejecutivo, necesitaba una opción discreta. Los alineadores fueron perfectos. El Dr. Garza explicó todo desde el inicio y el avance se sintió muy claro.',
    rating: 5,
    date: 'Octubre 2024',
    verified: true,
  },
  {
    id: 3,
    name: 'María Elena S.',
    treatment: 'Odontología Infantil',
    quote:
      'Mi hijo le tenía pánico al dentista hasta que conoció a la Dra. Mendoza. Ahora pregunta cuándo es su próxima cita. El trato con los niños es excepcional.',
    rating: 5,
    date: 'Septiembre 2024',
    verified: true,
  },
  {
    id: 4,
    name: 'Jorge Luis C.',
    treatment: 'Implante Dental',
    quote:
      'Perdí un diente en un accidente y pensé que sería complicado. La Dra. Villarreal me explicó todo con calma y el resultado quedó muy natural.',
    rating: 5,
    date: 'Agosto 2024',
    verified: true,
  },
  {
    id: 5,
    name: 'Alejandra T.',
    treatment: 'Blanqueamiento',
    quote:
      'Siempre quise un blanqueamiento pero temía la sensibilidad. Me explicaron el plan y avanzamos paso a paso. Quedé muy contenta con el resultado.',
    rating: 5,
    date: 'Julio 2024',
    verified: true,
  },
  {
    id: 6,
    name: 'Ricardo P.',
    treatment: 'Urgencia Dental',
    quote:
      'Se me fracturó un diente un viernes. Llamé el sábado temprano y me atendieron rápido. Fueron claros, cuidadosos y me solucionaron el problema.',
    rating: 5,
    date: 'Junio 2024',
    verified: true,
  },
];

export const BEFORE_AFTER_CASES = [
  {
    id: 1,
    title: 'Transformación con Carillas',
    description: 'Corrección de color, forma y alineación con 8 carillas de porcelana.',
    treatment: 'Carillas de Porcelana',
    duration: '3 semanas',
    beforeImage: 'https://images.unsplash.com/photo-1606811841689-23dfddce3e95?w=400&q=80',
    afterImage: 'https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=400&q=80',
  },
  {
    id: 2,
    title: 'Corrección de Mordida',
    description: 'Tratamiento de apiñamiento severo con alineadores transparentes.',
    treatment: 'Ortodoncia Invisible',
    duration: '14 meses',
    beforeImage: 'https://images.unsplash.com/photo-1606811841689-23dfddce3e95?w=400&q=80',
    afterImage: 'https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=400&q=80',
  },
  {
    id: 3,
    title: 'Rehabilitación con Implantes',
    description: 'Reemplazo de 3 piezas posteriores con implantes de titanio.',
    treatment: 'Implantes Dentales',
    duration: '4 meses',
    beforeImage: 'https://images.unsplash.com/photo-1606811841689-23dfddce3e95?w=400&q=80',
    afterImage: 'https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=400&q=80',
  },
];

export const CONSULTATION_REASONS = [
  'Primera consulta / Evaluación general',
  'Dolor o molestia dental',
  'Limpieza dental',
  'Blanqueamiento',
  'Ortodoncia / Alineadores',
  'Carillas / Diseño de sonrisa',
  'Implantes dentales',
  'Urgencia dental',
  'Consulta para mi hijo/a',
  'Otro',
];

export const TIME_PREFERENCES = [
  'Mañana (9:00 - 12:00)',
  'Mediodía (12:00 - 15:00)',
  'Tarde (15:00 - 19:00)',
  'Sábado',
  'El horario más próximo disponible',
];

export const IMAGES = {
  hero: 'https://images.unsplash.com/photo-1629909613654-28e377c37b09?w=1200&q=80',
  clinic1: 'https://images.unsplash.com/photo-1629909615184-74f495363b67?w=800&q=80',
  clinic2: 'https://images.unsplash.com/photo-1588776814546-1ffcf47267a5?w=800&q=80',
  smile: 'https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=800&q=80',
  technology: 'https://images.unsplash.com/photo-1609840114035-3c981b782dfe?w=800&q=80',
};

export const FIRST_VISIT_STEPS = [
  { step: 1, title: 'Agenda tu cita', description: 'Por WhatsApp o en línea, elige el horario que te funcione.' },
  { step: 2, title: 'Evaluación completa', description: 'Radiografías digitales, revisión y diagnóstico detallado.' },
  { step: 3, title: 'Plan personalizado', description: 'Te explicamos opciones, tiempos y costos por escrito.' },
  { step: 4, title: 'Tú decides', description: 'Sin presión. Resolvemos dudas y avanzamos cuando estés listo.' },
];

export const TRUST_BADGES = [
  { label: 'Google', value: '4.9/5', detail: '347 reseñas' },
  { label: 'Experiencia', value: '15+', detail: 'años' },
  { label: 'Pacientes', value: '2,500+', detail: 'atendidos' },
];
